import { useState } from "react";
import useReveal from "./useReveal";

const nf = (n) => Math.round(n).toLocaleString("ru-RU");
const money = (n) => `${nf(n)} ₽`;

const RoiCalculator = () => {
    const [ref, visible] = useReveal();
    const [price, setPrice] = useState(500);
    const [count, setCount] = useState(200);
    const [conv, setConv] = useState(12);
    const [check, setCheck] = useState(40000);

    const spend = price * count;
    const deals = (count * conv) / 100;
    const rev = deals * check;
    const profit = rev - spend;
    const roi = spend ? (profit / spend) * 100 : 0;

    return (
        <section
            className={`sect sect--soft reveal${visible ? " is-in" : ""}`}
            id="roi"
            ref={ref}
        >
            <div className="wrap">
                <div className="sect__head">
                    <span className="eyebrow">Экономика</span>
                    <h2 className="sect__title">Посчитайте выгоду от покупки лидов для юристов</h2>
                    <p className="sect__lead">
                        Подставьте свои цифры — конверсию в договор и средний чек вы знаете
                        лучше нас.
                    </p>
                </div>

                <div className="calc">
                    <div className="calc__inputs">
                        <div className="field">
                            <label htmlFor="r-price">Цена одного лида, ₽</label>
                            <div className="range">
                                <input
                                    id="r-price"
                                    type="range"
                                    min="100"
                                    max="2500"
                                    step="50"
                                    value={price}
                                    onChange={(e) => setPrice(Number(e.target.value))}
                                />
                                <output>{money(price)}</output>
                            </div>
                        </div>
                        <div className="field">
                            <label htmlFor="r-count">Лидов в месяц</label>
                            <div className="range">
                                <input
                                    id="r-count"
                                    type="range"
                                    min="20"
                                    max="1000"
                                    step="10"
                                    value={count}
                                    onChange={(e) => setCount(Number(e.target.value))}
                                />
                                <output>{nf(count)} шт.</output>
                            </div>
                        </div>
                        <div className="field">
                            <label htmlFor="r-conv">Конверсия из лида в договор, %</label>
                            <div className="range">
                                <input
                                    id="r-conv"
                                    type="range"
                                    min="1"
                                    max="40"
                                    step="1"
                                    value={conv}
                                    onChange={(e) => setConv(Number(e.target.value))}
                                />
                                <output>{conv} %</output>
                            </div>
                        </div>
                        <div className="field">
                            <label htmlFor="r-check">Средний чек договора, ₽</label>
                            <div className="range">
                                <input
                                    id="r-check"
                                    type="range"
                                    min="5000"
                                    max="300000"
                                    step="5000"
                                    value={check}
                                    onChange={(e) => setCheck(Number(e.target.value))}
                                />
                                <output>{money(check)}</output>
                            </div>
                        </div>
                    </div>

                    <div className="calc__result">
                        <div className="res">
                            <div className="res__row">
                                <span>Расходы на лиды</span>
                                <b>{money(spend)}</b>
                            </div>
                            <div className="res__row">
                                <span>Заключено договоров</span>
                                <b>{(deals < 10 ? deals.toFixed(1) : nf(deals))} шт.</b>
                            </div>
                            <div className="res__row">
                                <span>Выручка</span>
                                <b>{money(rev)}</b>
                            </div>
                            <div className="res__row res__row--hl">
                                <span>Прибыль за месяц</span>
                                <b style={{ color: profit >= 0 ? undefined : "#FF9A8A" }}>
                                    {profit >= 0 ? "" : "−"}
                                    {money(Math.abs(profit))}
                                </b>
                            </div>
                            <div className="res__row res__row--hl">
                                <span>Рентабельность вложений</span>
                                <b>{nf(roi)} %</b>
                            </div>
                            <div className="res__row">
                                <span>Стоимость привлечения одного договора</span>
                                <b>{deals >= 0.1 ? money(spend / deals) : "—"}</b>
                            </div>
                        </div>
                        <p className="res__note">
                            Расчёт ориентировочный: реальные цифры зависят от скорости прозвона,
                            скрипта и региона.
                        </p>
                        <a href="#order" className="btn btn--block">
                            Обсудить условия под мои цифры
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RoiCalculator;
